/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-05-24 10:45:56.

export enum Acionamento {
    TORRE = "Acionamento de Torre",
    CAMPO = "Acionamento de Campo",
    INSPECAO = "Durante a Inspeção",
}

export enum AtributoEspecime {
    observacoes = "Observações",
    arquivos = "Arquivos",
    tipoMarcacao = "Tipo de Marcação",
    formasRegistro = "Formas de Registro",
    observadores = "Observadores",
    comportamento = "Comportamento",
    guia = "Guia",
    instituicaoDepositaria = "Instituição Depositária",
    meteorologias = "Dados meteorológicos",
    sexo = "Sexo",
    classeEtaria = "Classe Etária",
    tempo = "Tempo",
    comprimentoTotal = "Comprimento Total",
    comprimentoCabeca = "Comprimento da Cabeça",
    comprimentoCauda = "Comprimento da Cauda",
    comprimentoAsa = "Comprimento da Asa",
    comprimentoTarso = "Comprimento do Tarso",
    diametroTarso = "Diâmetro do Tarso",
    pesoCorporal = "Peso Corporal",
    comprimentoBico = "Comprimento do Bico",
    dinamicaSocial = "Dinâmica Social",
    larguraBico = "Largura do Bico",
    alturaBico = "Altura do Bico",
    gorduraSubcutanea = "Gordura Subcutânea",
    placaIncubacao = "Placa de Incubação",
    mudaPenas = "Muda de Penas",
    destino = "Destino",
    numeroTombamento = "Número do Tombametno",
    numeroMarcacao = "Número da Marcação",
    individuos = "Nº de Indivíduos",
    temperaturaAr = "Temperatura do Ar",
    comprimentoRostroCloacal = "Comprimento do Rostro Cloacal",
    comprimentoPadrao = "Comprimento Padrão",
    estagioMaturacaoGonadal = "Estágio de Maturação Gonadal",
    comprimentoCorpo = "Comprimento do Corpo",
    comprimentoPataTraseira = "Comprimento da Pata Traseira",
    larguraCabeca = "Largura da Cabeça",
    comprimentoTronco = "Comprimento do Tronco",
    alturaCinturaPelvica = "Altura da Cintura Pélvica",
    larguraCinturaPelvica = "Largura da Cintura Pélvica",
    circunferenciaTorax = "Circunferência do Tórax",
    circunferenciaCabeca = "Circunferência da Cabeça",
    acionamento = "Acionamento",
    estado = "Estado",
    necrocia = "Necrocia",
    oleado = "Oleado",
    dataHoraSoltura = "Data/Hora da Soltura",
    areaSoltura = "Área de Soltura",
    circunferenciaPescoco = "Circunferência do Pescoço",
    comprimentoOrelha = "Comprimento da Orellha",
    distanciaInterOlhos = "Distância InterOlhos",
    larguraMandibula = "Largura da Mandíbula",
    prenha = "Prenha?",
    lactando = "Lactando?",
    numeroFilhotes = "Número de Filhotes",
    glandulasMamarias = "Glândulas Mamárias",
    aberturaVaginal = "Abertura Vaginal",
    escrotado = "Escrotado",
    comprimentoPe = "Comprimento do Pé",
    comprimentoAnteBraco = "Comprimento do antebraço",
}

export enum AtributoMonitoramento {
    ALTURA_REDE = "Altura da Rede (m)",
    COMPRIMENTO_REDE = "Comprimento da Rede (m)",
    DISTANCIA_PERCORRIDA = "Distância Percorrida (m)",
    INDICADOR_ESTRATO = "Estrato",
    NOME_ARMADILHA = "Nome da Armadilha",
    NOME_TRANSECTO = "Nome do Transecto",
    NUMERO_REDE = "Número de Redes",
    NUMERO_DISPAROS = "Número de Disparos",
    NUMERO_REGISTROS = "Número de Registros",
    PONTO_CAPTURA = "Ponto de Captura",
    INDICADOR_POSICAO = "Posição/Lado",
    QUANTIDADE_ARMADILHA = "Quantidade de Armadilhas",
    QUANTIDADE_LANCES = "Quantidade de Lances",
    QUANTIDADE_PARCELAS = "Quantidade de Parcelas",
    QUANTIDADE_PASSADAS = "Quantidade de Passadas",
    TAMANHO_MALHA = "Tamanho da Malha",
}

export enum ClasseEtaria {
    ADULTO = "Adulto",
    JOVEM = "Jovem",
    FILHOTE = "Filhote",
    INDETERMINADO = "Indeterminado",
}

export enum Destino {
    CONSERVACAO = "Conservação",
    DEPOSITO = "Depósito",
    DESCARTE = "Descarte",
    FUGIU = "Fugiu",
    SOLTURA = "Soltura",
}

export enum Dinamica {
    BANDO = "Bando",
    CASAL = "Casal",
    SOLITARIO = "Solitário",
}

export enum EstacaoChuva {
    CHUVOSA = "Chuvosa",
    SECA = "Seca",
    VERAO = "Verão",
    OUTONO = "Outono",
    INVERNO = "Inverno",
    PRIMAVERA = "Primavera",
}

export enum EstagioMaturacao {
    IM = "IM",
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",
}

export enum Estrato {
    DS = "Dossel",
    SL = "Solo",
    SB = "SubBosque",
}

export enum FaseLunar {
    CH = "Cheia",
    CS = "Crescente",
    MG = "Minguante",
    NV = "Nova",
}

export enum FormaRegistro {
    VISUALIZACAO = "Visualização",
    VOCALIZACAO = "Vocalização",
    CAPTURA = "Captura",
    CARCACA = "Carcaça",
    CHEIRO = "Cheiro",
    COLETA = "Coleta",
    ESPINHO = "Espinho",
    FEZES = "Fezes",
    FOTO = "Foto",
    MARCA = "Marca",
    PEGADA = "Pegada",
    PELO = "Pelo",
    RECAPTURA = "Recaptura",
    REGUGITO = "Regugito",
    TOCA = "Toca",
}

export enum Funcao {
    OBSERVADOR = "Observador",
    INSTITUICAO = "Instituição",
    VETERINARIO = "Veterinário",
    GUIA = "Guia",
}

export enum Grupo {
    AVF = "Avifauna",
    ETF = "Entomofauna",
    HPF = "Herpetofauna",
    ICF = "Ictiofauna",
    MTF = "Mastofauna",
    QPF = "Quiropterofauna",
}

export enum Posicao {
    E = "Esquerdo",
    D = "Direito",
}

export enum Sexo {
    FEMEA = "Fêmea",
    MACHO = "Macho",
    INDETERMINADO = "Indeterminado",
}

export enum SimNaoAparente {
    SIM = "Sim",
    NAO = "Não",
    NAP = "Não Aparentemente",
}

export enum SituacaoEspecime {
    VIVO = "Vivo",
    FERIDO = "Ferido",
    MORTO = "Morto",
}

export enum Tempo {
    A = "Céu Aberto",
    N = "Nublado",
    C = "Chuvoso",
}

export enum TipoAreaAmostral {
    CONSERVACAO_PRIVADA = "Área de Conservação Privada",
    CONSERVACAO_REGIONAL = "Área de Conservação Regional",
    BOSQUE_PROTECAO = "Bosque de Proteção",
    OUTROS = "Outros",
    PARQUE_NACIONAL = "Parque Nacional",
    REFUGIO_VIDA_SILVESTRE = "Refúgio de Vida Silvestre",
    RESERVA_COMUNAL = "Reserva Comunal",
    RESERVA_NACIONAL = "Reserva Nacional",
    RESERVA_PAISAGISTICA = "Reserva Paisagística",
    SANTUARIO_HISTORICO = "Santuário Histórico",
    SANTUARIO_NACIONAL = "Santuário Nacional",
    ILHAS = "Sistema de Ilhotas e Ilhas",
    UNIDADE_CONSERVACAO = "Unidade de Conservação",
    ZONA_RESERVADA = "Zona Reservada",
}

export enum TipoMeteorologia {
    TAR = "Temperatura do Ar",
    TAG = "Temperatura da Água",
    URA = "Umidade Relativa do Ar",
}
